import { defineComponent as V, openBlock as a, createElementBlock as o, mergeProps as i, unref as e, renderSlot as p, createElementVNode as l, createCommentVNode as m } from "vue";
import { useScalarIcon as u } from "../hooks/useScalarIcon.js";
const Z = { key: 0 }, g = { key: 1 }, v = { key: 2 }, A = { key: 3 }, M = { key: 4 }, f = { key: 5 }, k = {
  name: "ScalarIconAlignLeftSimple"
}, y = /* @__PURE__ */ V({
  ...k,
  props: {
    label: {},
    weight: {}
  },
  setup(r) {
    const s = r, { bind: H, weight: n } = u(s);
    return (d, t) => (a(), o("svg", i({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      fill: "currentColor"
    }, e(H)), [
      p(d.$slots, "default"),
      e(n) === "bold" ? (a(), o("g", Z, t[0] || (t[0] = [
        l("path", { d: "M44,56V200a12,12,0,0,1-24,0V56a12,12,0,0,1,24,0ZM244,96v64a20,20,0,0,1-20,20H80a20,20,0,0,1-20-20V96A20,20,0,0,1,80,76H224A20,20,0,0,1,244,96Zm-24,4H84v56H220Z" }, null, -1)
      ]))) : e(n) === "duotone" ? (a(), o("g", g, t[1] || (t[1] = [
        l("path", {
          d: "M232,96v64a8,8,0,0,1-8,8H72a8,8,0,0,1-8-8V96a8,8,0,0,1,8-8H224A8,8,0,0,1,232,96Z",
          opacity: "0.2"
        }, null, -1),
        l("path", { d: "M40,56V200a8,8,0,0,1-16,0V56a8,8,0,0,1,16,0ZM240,96v64a16,16,0,0,1-16,16H72a16,16,0,0,1-16-16V96A16,16,0,0,1,72,80H224A16,16,0,0,1,240,96Zm-16,64V96H72v64H224Z" }, null, -1)
      ]))) : e(n) === "fill" ? (a(), o("g", v, t[2] || (t[2] = [
        l("path", { d: "M40,56V200a8,8,0,0,1-16,0V56a8,8,0,0,1,16,0ZM224,80H72A16,16,0,0,0,56,96v64a16,16,0,0,0,16,16H224a16,16,0,0,0,16-16V96A16,16,0,0,0,224,80Z" }, null, -1)
      ]))) : e(n) === "light" ? (a(), o("g", A, t[3] || (t[3] = [
        l("path", { d: "M38,56V200a6,6,0,0,1-12,0V56a6,6,0,0,1,12,0ZM238,96v64a14,14,0,0,1-14,14H72a14,14,0,0,1-14-14V96A14,14,0,0,1,72,82H224A14,14,0,0,1,238,96Zm-12,0a2,2,0,0,0-2-2H72a2,2,0,0,0-2,2v64a2,2,0,0,0,2,2H224a2,2,0,0,0,2-2Z" }, null, -1)
      ]))) : e(n) === "regular" ? (a(), o("g", M, t[4] || (t[4] = [
        l("path", { d: "M40,56V200a8,8,0,0,1-16,0V56a8,8,0,0,1,16,0ZM240,96v64a16,16,0,0,1-16,16H72a16,16,0,0,1-16-16V96A16,16,0,0,1,72,80H224A16,16,0,0,1,240,96Zm-16,64V96H72v64H224Z" }, null, -1)
      ]))) : e(n) === "thin" ? (a(), o("g", f, t[5] || (t[5] = [
        l("path", { d: "M36,56V200a4,4,0,0,1-8,0V56a4,4,0,0,1,8,0ZM236,96v64a12,12,0,0,1-12,12H72a12,12,0,0,1-12-12V96A12,12,0,0,1,72,84H224A12,12,0,0,1,236,96Zm-8,0a4,4,0,0,0-4-4H72a4,4,0,0,0-4,4v64a4,4,0,0,0,4,4H224a4,4,0,0,0,4-4Z" }, null, -1)
      ]))) : m("", !0)
    ], 16));
  }
});
export {
  y as default
};
